export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6223.47bece2c.jpg";